import { useGetStudentsByApplicationStatus } from '@actions';
import Modal from '@components/V4/Modal/Modal';
import { PaginationProps } from '@components/V4/Pagination';
import DetailsModal, {
  DetailsModalPage,
} from '@modules/Admin/components/DetailsModal/DetailsModal';
import { GOAL_STATUS_OPTIONS } from '@shared/constants/profile';
import { UserRole } from '@shared/enums';
import { useState } from 'react';
import ProfilesModalTable from '../ProfilesModalTable';

interface StudentsByApplicationStatusProps {
  status: string;
  title: string;
}

const StudentsByApplicationStatus = (props: StudentsByApplicationStatusProps) => {
  const { status, title } = props;
  const [limit, setLimit] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState<null>(null);

  const numericStatus = GOAL_STATUS_OPTIONS.find((option) => option.label === status)?.value;

  const { data: studentsByApplicationStatus, isLoading: areUsersLoading } =
    useGetStudentsByApplicationStatus({
      limit,
      page,
      sortBy,
      sortOrder,
      status: numericStatus || 0,
    });

  const currentPageChangeHandler = (page: number) => {
    setPage(page);
  };

  const pageSizeChangeHandler = (size: number) => {
    setLimit(size);
  };

  const pagination: PaginationProps = {
    pageSize: limit,
    total: studentsByApplicationStatus ? studentsByApplicationStatus.total : 0,
    currentPage: page,
    onCurrentPageChange: currentPageChangeHandler,
    onPageSizeChange: pageSizeChangeHandler,
  };

  const usersList = studentsByApplicationStatus?.users;

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [userId, setUserId] = useState<string>();
  const [modalPage, setModalPage] = useState<DetailsModalPage>('student');

  const userModalOpenHandler = (userId: string) => {
    setModalPage('student');
    setUserId(userId);
    setShowDetailsModal(true);
  };

  const closeSessionModalHandler = () => {
    setShowDetailsModal(false);
    setUserId(undefined);
    setModalPage(undefined);
  };

  return (
    <>
      <Modal.Header title={`Students from ${title}:`} />
      <Modal.Body>
        <ProfilesModalTable
          usersList={usersList || []}
          areUsersLoading={areUsersLoading}
          pagination={pagination}
          userModalOpenHandler={userModalOpenHandler}
          role={UserRole.Student}
        />
      </Modal.Body>
      {showDetailsModal && (
        <DetailsModal
          page={modalPage}
          isOpen={true}
          onClose={closeSessionModalHandler}
          studentId={userId}
        />
      )}
    </>
  );
};

export default StudentsByApplicationStatus;
